export default [
  'fetch_locations@list',
  'fetch_location@single',
  'update_location@single',
  'create_location@created',
  'remove_location',
];
